import React from 'react'
import { 
  Users, 
  Activity, 
  TrendingUp, 
  AlertCircle 
} from 'lucide-react'

export default function Dashboard() {
  const stats = [
    {
      name: '총 사용자',
      value: '2,345',
      change: '+12%',
      changeType: 'positive',
      icon: Users,
    },
    {
      name: '활성 사용자',
      value: '1,234',
      change: '+8%',
      changeType: 'positive',
      icon: Activity,
    },
    {
      name: '성장률',
      value: '24.5%',
      change: '+2.1%',
      changeType: 'positive',
      icon: TrendingUp,
    },
    {
      name: '오류 발생',
      value: '12',
      change: '-3',
      changeType: 'negative',
      icon: AlertCircle,
    },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">대시보드</h1>
        <p className="mt-1 text-sm text-gray-500">
          EXPLAT 콘솔의 전체 현황을 확인하세요.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div key={stat.name} className="card">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <stat.icon className="h-8 w-8 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    {stat.name}
                  </dt>
                  <dd className="flex items-baseline">
                    <div className="text-2xl font-semibold text-gray-900">
                      {stat.value}
                    </div>
                    <div className={`ml-2 flex items-baseline text-sm font-semibold ${
                      stat.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                    }`}>
                      {stat.change}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">최근 활동</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <div className="h-2 w-2 bg-green-400 rounded-full"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-900">새로운 사용자가 가입했습니다</p>
                <p className="text-xs text-gray-500">2분 전</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <div className="h-2 w-2 bg-blue-400 rounded-full"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-900">시스템 업데이트가 완료되었습니다</p>
                <p className="text-xs text-gray-500">1시간 전</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <div className="h-2 w-2 bg-yellow-400 rounded-full"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-900">서버 리소스 사용량이 높습니다</p>
                <p className="text-xs text-gray-500">3시간 전</p>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <h3 className="text-lg font-medium text-gray-900 mb-4">빠른 작업</h3>
          <div className="space-y-3">
            <button className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
              <div className="font-medium text-gray-900">사용자 초대</div>
              <div className="text-sm text-gray-500">새로운 사용자를 초대하세요</div>
            </button>
            <button className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
              <div className="font-medium text-gray-900">시스템 설정</div>
              <div className="text-sm text-gray-500">시스템 설정을 변경하세요</div>
            </button>
            <button className="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
              <div className="font-medium text-gray-900">데이터 백업</div>
              <div className="text-sm text-gray-500">데이터를 백업하세요</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
